Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Widget.Messages.BindControl, 'x-product-review-box', function (envelope) {

        var $context = envelope.message.data.context,
            $boxes = $('.x-product-review-box', $context);

        if ($boxes.length < 1) return;

        $boxes.each(function (i, box) {

            var $box = $(box);

            var reviewId = $box.data('reviewid');
            var sessionIsAuthenticated = $box.data('session-is-authenticated'); 
            var currentUserVotedForHelpfullness = $box.data('current-user-voted-for-helpfullness');           

            var $loginPopup = $('div[data-type="helpfullness-login-popup"]', $box);

            var $btnVote = $box.find('.vote-btn');
            var $btnVoteYes = $box.find('*:enabled[data-click="vote-yes"]');
            var $voteYesInputWrapper = $btnVoteYes.parent();
            var $btnVoteNo = $box.find('*:enabled[data-click="vote-no"]');
            var $voteNoInputWrapper = $btnVoteNo.parent();
            var $totalYesVotes = $box.find('*[data-input="helpfullness-yes-total"]');
            var $totalNoVotes = $box.find('*[data-input="helpfullness-no-total"]');
            var $userVotedMessage = $box.find('.user-voted');
            var $voteError = $box.find('.vote-msg-error');

            function yesVoteSuccess(response) {
                if (response.success) {
                    $totalYesVotes.val(parseInt($totalYesVotes.val()) + 1);
                    $btnVoteYes.prop('disabled', true);
                    $voteYesInputWrapper.addClass('x-disabled');
                    $btnVoteNo.prop('disabled', true);
                    $voteNoInputWrapper.addClass('x-disabled');
                    $userVotedMessage.show();

                } else {
                    $voteError.html(LhApp.Function.getText('Validation:' + response.code));
                    $voteError.show();
                };
            };

            function noVoteSuccess(response) {
                if (response.success) {
                    $totalNoVotes.val(parseInt($totalNoVotes.val()) + 1);
                    $btnVoteYes.prop('disabled', true);
                    $voteYesInputWrapper.addClass('x-disabled');
                    $btnVoteNo.prop('disabled', true);
                    $voteNoInputWrapper.addClass('x-disabled');
                    $userVotedMessage.show();

                } else {
                    $voteError.html(LhApp.Function.getText('Validation:' + response.code));
                    $voteError.show();
                };
            };

            function voteFailure(response) {
                $voteError.html(LhApp.Function.getText('Validation:' + response.code));
                $voteError.show();
            };

            $btnVote.click(function (e) {
                if (sessionIsAuthenticated) {
                    if (!currentUserVotedForHelpfullness) {
                        $voteError.hide();
                        if ($(this).hasClass('vote-btn-yes')) {
                            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Product.Messages.ReviewVote(reviewId, true));
                        } else if ($(this).hasClass('vote-btn-no')) {
                            Vendd.MessageBus.publishAsync(wrapper, new Vendd.Product.Messages.ReviewVote(reviewId, false));
                        }

                        Vendd.MessageBus.subscribe(Vendd.Product.Messages.ReviewVoteSuccess, wrapper, function (envelope) {
                            if (envelope.message.data.vote === true) {
                                yesVoteSuccess(envelope.message.data.response)
                            } else {
                                noVoteSuccess(envelope.message.data.response)
                            };
                            Vendd.MessageBus.unsubscribe(Vendd.Product.Messages.ReviewVoteSuccess, wrapper);
                        });

                        Vendd.MessageBus.subscribe(Vendd.Product.Messages.ReviewVoteFailure, wrapper, function (envelope) {
                            voteFailure(envelope.message.data.response);
                            Vendd.MessageBus.unsubscribe(Vendd.Product.Messages.ReviewVoteFailure, wrapper);
                        });

                    };
                } else {
                    $loginPopup.show();
                };
            });

            if (!sessionIsAuthenticated) {

                var $loginLink = $('*[data-click="login"]', $loginPopup);
                var $registerLink = $('*[data-click="register"]', $loginPopup);
                var $closeBtn = $('*[data-click="close-popup"]', $loginPopup);

                var $loginWidget = $('.x-control.x-widget.x-login-widget').first();
                var redirectUrl = LhApp.Function.Url.setParameterValue('mode', 'view-reviews');

                $loginLink.click(function (e) {
                    $loginPopup.hide();

                    var $loginForm = $('.x-login-form .login-form', $loginWidget);
                    $loginForm.attr('data-redirect', redirectUrl);

                    $('.js-widget-trigger', $loginWidget).trigger('click');
                });

                $registerLink.click(function (e) {
                    document.location = LhApp.Function.Url.setParameterValueOnUrl(LhApp.Url.Page.Register, 'ReturnUrl', encodeURIComponent(redirectUrl));
                });

                $closeBtn.click(function (e) {
                    $loginPopup.hide();
                });
            } else {
                $loginPopup.remove();
            }
        });

    });

});